type Noop = (...args: unknown[]) => unknown;
type Transformer<T, R> = (arg: T, index?: number) => R;

export const noop: Noop = () => null;
export const identity = <T>(arg: T) => arg;

export function indexBy<T, Key extends keyof T, TransformResult = T>(
  items: T[],
  key: Key,
  transform: Transformer<T, TransformResult> = identity as Transformer<
    T,
    TransformResult
  >,
) {
  const indexedMap = new Map<T[Key], TransformResult>();

  for (const item of items) {
    indexedMap.set(item[key], transform(item));
  }

  return indexedMap;
}
